export const LOAD_SATANNOTATIONS = "LOAD_SATANNOTATIONS";
export const LOAD_SATANNOTATIONS_SUCCESS = "LOAD_SATANNOTATIONS_SUCCESS";
export const LOAD_SATANNOTATIONS_ERROR = "LOAD_SATANNOTATIONS_ERROR";
